//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import { format } from "date-fns";
	import { mapGetters } from "vuex";
	import TransitionExpand from "../../lib/transitions/ExpandItem";
	
	import sameOriginCheck from "../../../global/mixins/sameOriginCheck";

	export default {
		name: "AppResult",
		props: {
			result: Object,
			index: Number,
			results: Array,
		},
		components: {
			TransitionExpand
		},
		data() {
			return {
				containerEl: null,
				containerWidth: null,
				left: null,
				resultRowMates: null,
				expanded: false,
				height: 0,
				currentUrl: window.location,
				dropdownContent: this.result.meta.dropdownContent,
				sameOrigin: sameOriginCheck(this.result.url, window.location),
			};
		},
		computed: {
			...mapGetters([
				"siteName"
			]),
			cardIsLink() {
				return this.result.meta.showDetailPage && (!this.result.meta.linkText || this.siteName == 'ORG');
			},
			cardIsClickable() {
				return this.cardIsLink || !this.result.meta.linkText || this.siteName == 'ORG';
			},
			isExternalLink() {
				return !sameOriginCheck(this.result.url, this.currentUrl);
			},
			showBusinessArea() {
				return (!document.querySelector(".page--BUY")) && // TASB does NOT want this showing on BuyBoard listing pages as of 08/28/2024
					(this.config.showProvidingOrganization || this.isExternalLink) &&
					(!!this.result.meta.businessAreaName || !!this.result.meta.businessAreaColor);
			},
			resultClasses() {
				return { 
					'app-result--expanded': this.expanded, 
					'app-result--no-media': this.siteName == 'ORG' && (!this.config.showResultImage || !this.result.image),
					'app-result--default-border': !this.config.showProvidingOrganization || !this.result.meta.businessAreaColor || this.result.meta.businessAreaColor == "" || this.config.showResultImage,
					'app-result--clickable': this.cardIsClickable,
					'app-result--external': this.isExternalLink,
					'app-result--access': this.result.meta.memberAccess == true,
				}
			},
			imageAltText() {
				return this.result.imageAltText || this.result.meta.imageAltText || this.result.title || "";
			},
			style() {
				return {
					width: `${this.containerWidth}px`,
					maxWidth: `${this.containerWidth}px`,
					left: `${this.left}px`,
				}
			},
			linkLabel() {
				return this.result.meta.showDetailPage ? "" :
					this.expanded ? "Collapse service details" :
					"Expand service details";
			},
			displayDate() {
				if (this.result.meta.type.toLowerCase() == "legislative summary") return format(new Date(this.result.itemDate), "yyyy");
				return format(new Date(this.result.itemDate), "MMM d, yyyy");
			},
			sessionDate(){
				return format(new Date(this.result.meta.sessionDate), "MMM d, yyyy hh:mm a");
			},
			renderMediaDiv() {
				return this.config.showResultImage && (!!this.result.image || (this.siteName != 'ORG' && !!this.result.icon));
			},
			topHighlights() {
				return this.result.highlights.slice(0, 3);
			}
		},
		watch: {
			expanded(newVal, oldVal) {
				this.height = this.$el.querySelector(".app-result__expander-inner").offsetHeight;
			}
		},
		methods: {
			addEllipses(htmlString) {
				while (htmlString.endsWith(".")) htmlString = htmlString.slice(0, -1);
				return `...${htmlString.trim()}...`;
			},
			setDataValues() {
				this.containerWidth = this.containerEl.offsetWidth;

				const resultLeft = this.$el.getBoundingClientRect().left;
				const containerLeft = this.containerEl.getBoundingClientRect().left;
				this.left = containerLeft - resultLeft;

				let row = [];
				let top = this.$el.getBoundingClientRect().top;
				const cards = [...this.containerEl.querySelectorAll(".app-result")];
				cards.forEach(c => {
					if (c.getBoundingClientRect().top > (top - 8) && c.getBoundingClientRect().top < (top + 8)) {
						row.push(c);
					}
				});
				this.resultRowMates = row;
			},
			async loadData() {
				if (this.config.previewEndpoint && !this.dropdownContent)
				{
					const response = await fetch(`${this.config.previewEndpoint}/${this.result.key}`, {
						method: 'GET',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						redirect: 'follow',
						referrerPolicy: 'no-referrer'
					});

					if (response.ok) {
						this.dropdownContent = await response.text();
					} else {
						this.dropdownContent = '<h3>Sorry, there was an error retrieving this content.</h3>'
					}
				}
			},
			handleLinkClick(e) {
				if (!!e.target.closest(".app-result__expander-inner")) return;
				if (!this.result.meta.showDetailPage) {
					e.preventDefault();
					this.$root.$emit('toggling', this.result.key);
					this.setDataValues();
					const cards = [...this.containerEl.querySelectorAll(".app-result")];
					cards.forEach(c => {
						if (!!c.style.marginBottom) c.style.marginBottom = "";
					})
					this.expanded = !this.expanded;
					if (this.expanded) {
						this.loadData().then(() => {
							this.resultRowMates.forEach(card => {
								const height = this.$el.querySelector(".app-result__expander-inner").offsetHeight;
								card.style.marginBottom = `${height + 16}px`;
							});
							this.setDataValues();
						});
						this.$el.querySelector("button.app-result__expander-close").focus();
					} else {
						this.resultRowMates.forEach(card => card.style.marginBottom = "");
						if (this.result.linkText) this.$el.querySelector("a.app-result__link")?.focus();
					}
				}
			},
			closeExpander(excludeFocus) {
				this.setDataValues();
				this.expanded = false;
				this.resultRowMates.forEach(card => card.style.marginBottom = "");
				if (!excludeFocus) this.$el.querySelector("a.app-result__link")?.focus();
			},
		},
		created() { },
		mounted() {
			this.$root.$on('toggling', key => {
				if (key != this.result.key && this.$el.matches(".app-result--expanded")) this.closeExpander(true);
			});
			this.containerEl = this.$el.closest(".app-results");
			if (!!this.$el.querySelector(".app-result__expander")) {
				this.setDataValues();
				this.$el.querySelector(".app-result__expander").style.display = "";
				const cards = [...this.containerEl.querySelectorAll(".app-result")];
				cards.forEach(c => {
					if (c != this.$el) {
						const link = c.querySelector(".app-result__link--expand");
						if (!!link) {
							link.addEventListener("click", () => this.expanded = false);
						}
					}
				});
			}
		},
	};
